import { createFileRoute } from "@tanstack/react-router";
import { VideoWatchPage } from "@/components/VideoWatchPage";
import { watchVideos, watchVideoHead } from "@/data/watchVideos";

export const Route = createFileRoute("/videos/drop-curtains")({
  head: () => watchVideoHead(watchVideos.curtains),
  component: () => <VideoWatchPage video={watchVideos.curtains} />,
});